import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper'
import ListHeader from '@/common/components/ListHeader'
import Table from '@/common/components/Table'
import { useFilterParams } from '@/common/hooks/useFilterParams'
import { Mapper } from '@/common/services/mapper'
import { federalLotteriesColumns } from '@/features/federalLotteries/constants/columns.constant'
import { useFederalLotteries } from '@/features/federalLotteries/hooks/useFederalLotteries'
import { FederalLotteryTransformer } from '@/features/federalLotteries/services/federalLotteryTransformer'
import {
  FederalLotteriesContestData,
  FederalLotteriesContestTableItem,
} from '@/features/federalLotteries/types/federalLottery.type'
import { Award } from 'lucide-react'

const FederalLotteryList = () => {
  const { filterParams, setFilterParams } = useFilterParams()

  const {
    data: contests = [],
    meta,
    isLoading: contestsIsLoading,
    error: contestsError = {} as any,
    refetch,
  } = useFederalLotteries<FederalLotteriesContestTableItem[]>({
    filters: {
      page: filterParams.page || 1,
    },
    mapper: Mapper.mapWithTransformer<FederalLotteriesContestData[], FederalLotteriesContestTableItem[]>({
      transformer: FederalLotteryTransformer.tableTransformer(),
    }),
  })

  return (
    <div className="inner-screen gap-6">
      <ListHeader Icon={<Award className="size-10" strokeWidth={1.5} />} title="Concursos da Loteria Federal" />

      <ErrorMessageWrapper className="flex-1" statusCode={contestsError?.status} refetchFunction={refetch}>
        <div className="flex-1 overflow-auto flex flex-col gap-6">
          <Table
            columns={federalLotteriesColumns}
            rows={contests || []}
            isLoadingData={contestsIsLoading}
            page={filterParams.page || 1}
            totalPages={meta?.total_pages || 1}
            totalCount={meta?.total || 0}
            hasPagination
            setPage={(page) => setFilterParams((prev: any) => ({ ...prev, page }))}
            rowEmptyValue="--"
          />
        </div>
      </ErrorMessageWrapper>
    </div>
  )
}

export default FederalLotteryList
